import { useSelector } from 'react-redux';
import { isDateExpiredUTC } from '../utils/Utils';

/**
 * Shared hook for membership access control.
 * memberType values: 'normal' | 'trial' | 'pro' | 'VIP'
 */
export const useMemberAccess = () => {
  const user = useSelector((state) => state.authReducer);
  const memberType = user?.user?.memberType;
  const expiredTS = user?.user?.expiredTS;

  /** True when the user is on a free trial whose expiry date has already passed in UTC */
  const isTrialExpired = () => {
    if (memberType !== 'trial') return false;
    if (!expiredTS) return false;
    return isDateExpiredUTC(expiredTS);
  };

  /** True when the user has NO active membership (normal, or expired trial/pro/VIP) */
  const hasNoActiveMembership = () => {
    if (!user?.token || !user?.user || memberType === undefined) return false;
    if (memberType === 'normal') return true;
    if (expiredTS && isDateExpiredUTC(expiredTS)) return true;
    if (memberType === 'trial' || memberType === 'pro' || memberType === 'VIP') {
      return false;
    }
    return true;
  };

  /** True when the user is on an active (non-expired) free trial */
  const isActiveTrial = () => {
    return memberType === 'trial' && !isTrialExpired();
  };

  /** Formatted expiry date string YYYY.MM.DD */
  const formattedExpiry = expiredTS
    ? new Date(expiredTS).toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).replace(/\//g, '.')
    : '';

  return {
    memberType,
    expiredTS,
    isTrialExpired,
    hasNoActiveMembership,
    isActiveTrial,
    formattedExpiry,
  };
};

export default useMemberAccess;
